
import { useEffect } from 'react';
import { BuildingsNavbar } from './components/BuildingsNavbar';
import { MapSection } from './components/MapSection';
import { BuildingsFooter } from './components/BuildingsFooter';

export default function BuildingsSTR() {
  useEffect(() => {
    // Ensure the page scrolls to the top when this component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <BuildingsNavbar />
      <MapSection />
      <BuildingsFooter />
    </div>
  );
}
